<div class="wrapper">

  <div class="content">
  <div class="main">	

    <div class="form-warpper-content">

        <a class="form-wrapper-header" routerLink="/">
          <span class="logo"></span>
          <span class="form-wrapper-header-txt">CoinDepo</span>
        </a>  <!-- .form-wrapper-header -->
        <div class="form-wrapper-body">
            <div>
              <h3>
                {{'shared.not-found404.error-404' | translate}}
              </h3>
              <p>
                {{'shared.not-found404.page-cannot-be-found' | translate}}
              </p>
              <a routerLink="/" class="btn btn-secondary btn-lg  btn-min-w">
                {{'shared.not-found404.go-to' | translate}} CoinDepo
              </a>
            </div>
            <div>
              <img class="img-form-wrapper-body" [src]="staticUrl + 'assets/images/404man.png'" alt="">
            </div>
        </div> <!-- .form-wrapper-body -->
    </div> <!-- .form-wrapper-content -->
  </div> <!-- .main --> 
  </div><!-- .content -->
</div>
